import React, { useState } from 'react';
import { useForm } from "react-hook-form"
import logo from '../../images/logo.png'
import vehicleInfo from '../../data/vehicleInfo.json'
import { useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth'
import _ from 'lodash';

const DriverHelper = () => {

    const { setUser } = useAuth()
    const [vehicleType, setVehicleType] = useState("")
    const navigate = useNavigate()

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm()

    const onSubmit = (data) => {
        setUser({
            driver_name: data.name,
            helper_name: data.helper,
            driver_phone: data.phone,
            vehicle_type: data.type,
            vehicle_reg_no: data.vehicle
        })
        document.getElementById('vehicle_details_form').reset()
        navigate('/driver-outlets')
    }

    return (
        <div className='bg-brand'>
            <div className="container">
                <div className="d-flex justify-content-center align-items-center pt-3">
                    <img className='img-fluid' src={logo} alt="vehicle" />
                    <h1 style={{ lineHeight: '50px' }} className='fw-bold mt-2'>eTracker</h1>
                </div>

                <div className="">
                    <form id='vehicle_details_form' onSubmit={handleSubmit(onSubmit)}>

                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="floatingName" placeholder="Driver Name" {...register("name", { required: true })} />
                            <label htmlFor="floatingName">Driver Name</label>
                            {errors.name && <span className='text-brand-danger fw-bold'>Name required</span>}
                        </div>

                        <div className="form-floating mb-3">
                            <input type="text" className="form-control" id="floatingHelper" placeholder="Helper Name" {...register("helper", { required: true })} />
                            <label htmlFor="floatingHelper">Helper Name</label>
                            {errors.helper && <span className='text-brand-danger fw-bold'>Helper required</span>}
                        </div>

                        <div className="form-floating mb-3">
                            <input type="text" pattern="\d*" className="form-control" id="floatingPhone" placeholder="Driver Phone" {...register("phone", { required: true, pattern: /^(013|014|015|016|017|018|019)\d{8}$/ })} />
                            <label htmlFor="floatingPhone">Driver Phone</label>
                            {errors.phone && <span className='text-brand-danger fw-bold'>Correct Number required</span>}
                        </div>

                        <label className='mt-3 ps-1'>Vehicle Type</label><br />
                        <div className="bg-white p-2 mb-3 rounded shadow-sm">
                            <div onClick={() => setVehicleType(document.getElementById('Own Vehicle').value)} className="my-2">
                                <input type="radio" name="Own Vehicle" id="Own Vehicle" value={`Own Vehicle`} {...register("type", { required: true })} />
                                <label htmlFor="Own Vehicle" className='ms-1'>Own Vehicle</label>
                            </div>

                            <div onClick={() => setVehicleType(document.getElementById('Hired Vehicle').value)} className="my-2">
                                <input type="radio" name="Hired Vehicle" id="Hired Vehicle" value={`Hired Vehicle`} {...register("type", { required: true })} />
                                <label htmlFor="Hired Vehicle" className='ms-1'>Hired Vehicle</label>
                            </div>

                            {
                                vehicleType === 'Hired Vehicle' &&
                                <div className="form-floating mb-3">
                                    <input type="text" className="form-control" id="floatingVendor" placeholder="Vehicle Number" {...register("vehicle", { required: true })} />
                                    <label htmlFor="floatingVendor">Type Vehicle Number</label>
                                    {errors.vehicle && <span className='text-brand-danger fw-bold'>Vehicle Number required</span>}
                                </div>
                            }
                        </div>

                        {
                            vehicleType === 'Own Vehicle' &&
                            <>
                                <label className='ps-1'>Vehicle Selection</label>
                                <div className="bg-white shadow-sm rounded p-2 mb-3">
                                    <select {...register("vehicle")} className='w-100 py-2'>
                                        {
                                            _.sortBy([...new Set(vehicleInfo.map(vehicle => vehicle.no))]).map(item =>
                                                <option key={item} className='text-center py-1' value={item}>{item}</option>
                                            )
                                        }
                                    </select>
                                </div>
                            </>
                        }

                        <input className='btn-brand-submit w-100' type="submit" value={'Proceed'} />
                    </form>
                </div>
            </div>
        </div>
    );
};

export default DriverHelper;